import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WINDOW_DOOR_FEATURE_KEY, WindowDoorState, WINDOW_FEATURE_KEY } from './window-door.reducer';

// Lookup the 'WindowDoor' feature state managed by NgRx
const getWindowDoorState = createFeatureSelector<WindowDoorState>(WINDOW_DOOR_FEATURE_KEY);

const getWindowDoorConfiguration = createSelector(
    getWindowDoorState,
    (state: WindowDoorState) => {
        return state.configuration;
    }
);

export const windowDoorQuery = {
    getWindowDoorConfiguration,
};

// Legacy exports
export const windowQuery = windowDoorQuery;
